import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { track } from "../lib/analytics";
import { useAuthStore } from "../store";
import { T } from "../tokens";
import { Btn } from "../components/Btn";
import { AuthShell } from "../components/AuthShell";

// Result page for the email-verification link. The API GET /auth/verify-email
// marks the account verified then redirects here with ?verified=1|already|0.
export function VerifyEmail() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token    = useAuthStore(s => s.token);
  const state    = params.get("verified");   // "1" | "already" | "0" | null

  const ok = state === "1" || state === "already";
  useEffect(() => { if (state === "1") track("email_verified"); }, [state]);
  const emoji   = ok ? "✅" : "⚠️";
  const title   = state === "1" ? "Email verified"
                : state === "already" ? "Already verified"
                : "Verification failed";
  const message = state === "1" ? "Your email address is confirmed. Your account is fully set up."
                : state === "already" ? "This email was already verified — you're all set."
                : "This verification link is invalid or has expired. You can request a new one from your profile.";

  // Send members back into the app, guests to sign in.
  const cta = token ? { label: "Go to Caliber", to: "/" } : { label: "Sign in", to: "/login" };

  return (
    <AuthShell>
      <div style={{ width: "100%", padding: "32px", background: T.s1,
        border: `1px solid ${T.b0}`, borderRadius: "12px", textAlign: "center" }}>
        <div style={{ fontSize: "34px", marginBottom: "8px" }}>{emoji}</div>
        <h1 style={{ fontFamily: T.display, fontSize: "20px", fontWeight: 700, color: T.t0, margin: "0 0 8px" }}>{title}</h1>
        <p style={{ fontFamily: T.body, fontSize: "13px", color: T.t2, lineHeight: 1.6, margin: "0 0 20px" }}>{message}</p>
        <Btn variant="cta" size="md" onClick={() => navigate(cta.to)}>{cta.label}</Btn>
      </div>
    </AuthShell>
  );
}
